<div class="product">
    <div class="info" (click)="product.showcomp=!product.showcomp" *ngIf="product.comp">
        <img src="assets/images/icons/info.png" alt="info">
    </div>
    <div class="flip-container" [class.flipped]="product.showcomp">
        <div class="flipper">
            <div easyzoom *ngIf="loadAvatar" class="main-img"
                [ngClass]="{easyzoom:!product.showcomp,'easyzoom--overlay':!product.showcomp}">
                <img [src]="product.avatar|absolutePath:'products'"
                    [attr.data-zoom-image]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="main-img" *ngIf="!loadAvatar">
                <div class="loading"></div>
                <img appLazyLoad (lodedImage)="loadAvatar=true" [src]="product.avatar|absolutePath:'products'"
                    [alt]="'Livraison '+product.familyName+' '+product.name"
                    [title]="'Livraison '+product.familyName+' '+product.name" />
            </div>
            <div class="compositions back" *ngIf="product.showcomp">
                <div>
                    <ul>
                        <li *ngFor="let comp of product.comp|toArray">
                            {{comp}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="product-body">
        <h2>{{product.name}}</h2>
    </div>
    <div class="product-footer">
        <div class="size vcenter">
            <label *ngIf="product.sizes.length>1 || (product.sizes.length==1 && product.sizes[0].level)">
                <select *ngIf="product.sizes.length>1" class="form-control" [(ngModel)]="product.size">
                    <option *ngFor="let s of product.sizes;let j=index" [value]="j">{{s.size}}</option>
                </select>
                <p *ngIf="product.sizes.length==1 && product.sizes[0].level">{{product.sizes[0].size}}</p>
            </label>
            <div class="price text-right">
                <span>
                    {{product.sizes[product.size].price}} €
                </span>
            </div>
        </div>
        <div class="action vcenter">
            <ng-container *ngIf="!siteClose">
                <ng-container *ngIf="product.validPeriod==1">
                    <ng-container *ngIf="product.sizes[product.size]?.available">
                        <button class="btn personalize" aria-hidden="true" (click)="addToBasket()">
                            Ajouter au panier
                            <img src="assets/images/add.png" alt="" srcset="">
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!product.sizes[product.size]?.available">
                        <button class="btn indisponible">
                            Indisponible
                        </button>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="product.validPeriod==0">
                    <button class="btn indisponible" *ngIf="product.elementTime==1">Midi uniquement</button>
                    <button class="btn indisponible" *ngIf="product.elementTime==3">Soir uniquement</button>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="siteClose">
                <button class="btn indisponible">
                    Restaurant fermé
                </button>
            </ng-container>
        </div>
    </div>
</div>